import { Layout, Space } from "antd";
import "./Header.css";
import { ChangeLanguage } from "~pages/Shared/Root/components/Header/components/ChangeLanguage";
import { ChangeUserRole } from "~pages/Shared/Root/components/Header/components/ChangeUserRole";
import { HeaderLogo } from "./components/HeaderLogo";
import { UserHeaderProfile } from "./components/UserHeaderProfile";

export const Header = () => {
  return (
    <Layout.Header
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        position: "sticky",
        top: 0,
        zIndex: 1,
        borderBottom: "1px solid #ccc",
        padding: "0 25px",
        height: "50px",
      }}
    >
      <HeaderLogo />
      <Space size={15}>
        <ChangeUserRole />
        <ChangeLanguage />
        <UserHeaderProfile />
      </Space>
    </Layout.Header>
  );
};
